function cloneCanvasHistoryValue(value) {
  if (value === undefined) {
    return undefined;
  }
  if (typeof structuredClone === 'function') {
    return structuredClone(value);
  }
  return JSON.parse(JSON.stringify(value));
}

function areCanvasHistoryValuesEqual(left, right) {
  return JSON.stringify(left) === JSON.stringify(right);
}

function isCanvasHistoryPlainObject(value) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function restoreCanvasHistoryChangedFields(currentValue, beforeValue, afterValue) {
  if (areCanvasHistoryValuesEqual(beforeValue, afterValue)) {
    return currentValue;
  }

  if (
    isCanvasHistoryPlainObject(currentValue)
    && isCanvasHistoryPlainObject(beforeValue)
    && isCanvasHistoryPlainObject(afterValue)
  ) {
    const result = { ...currentValue };
    const keys = new Set([...Object.keys(beforeValue), ...Object.keys(afterValue)]);
    keys.forEach((key) => {
      const beforeHasKey = Object.prototype.hasOwnProperty.call(beforeValue, key);
      const afterHasKey = Object.prototype.hasOwnProperty.call(afterValue, key);
      if (!beforeHasKey && afterHasKey) {
        delete result[key];
        return;
      }
      if (beforeHasKey && !afterHasKey) {
        result[key] = cloneCanvasHistoryValue(beforeValue[key]);
        return;
      }
      result[key] = restoreCanvasHistoryChangedFields(result[key], beforeValue[key], afterValue[key]);
    });
    return result;
  }

  return cloneCanvasHistoryValue(beforeValue);
}

function mergeCanvasHistoryEdgesForUndo(currentEdges, beforeEdges, afterEdges) {
  const beforeEdgeById = new Map(beforeEdges.map((edge) => [edge.id, edge]));
  const afterEdgeById = new Map(afterEdges.map((edge) => [edge.id, edge]));
  const actionTouchedEdgeIds = new Set();

  afterEdges.forEach((afterEdge) => {
    const beforeEdge = beforeEdgeById.get(afterEdge.id);
    if (!beforeEdge || !areCanvasHistoryValuesEqual(beforeEdge, afterEdge)) {
      actionTouchedEdgeIds.add(afterEdge.id);
    }
  });
  beforeEdges.forEach((beforeEdge) => {
    const afterEdge = afterEdgeById.get(beforeEdge.id);
    if (!afterEdge || !areCanvasHistoryValuesEqual(beforeEdge, afterEdge)) {
      actionTouchedEdgeIds.add(beforeEdge.id);
    }
  });

  const mergedEdgeById = new Map();
  currentEdges.forEach((edge) => {
    if (!actionTouchedEdgeIds.has(edge.id)) {
      mergedEdgeById.set(edge.id, edge);
    }
  });
  beforeEdges.forEach((edge) => {
    if (actionTouchedEdgeIds.has(edge.id)) {
      mergedEdgeById.set(edge.id, cloneCanvasHistoryValue(edge));
    }
  });

  return Array.from(mergedEdgeById.values());
}

module.exports = {
  mergeCanvasHistoryEdgesForUndo,
  restoreCanvasHistoryChangedFields,
};
